var productionMode = false;
var environment = 'production';
var serverUrl = 'https://mon.qtrust.id:40013';
var serviceName = 'mpm-dashboard';
var secretToken = 'PpUw5ZibLVZFORV';
const gaId = 'G-WEDBBY6QK7';

const urlStart = 'https://mpm-dash.qtrust.id'; //please change this
const urlStartLog = 'https://mpm-dash-log.qtrust.id'; 

export default { productionMode , gaId , environment , serverUrl , serviceName , secretToken , urlStart, urlStartLog };
//export default {productionMode , urlStart};
